import axios from 'axios';
import { baseUrl } from "./endpoints";
import store from './../store'

function createInstance() {
    const instance = axios.create({
        baseURL: baseUrl,
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json",
            "Authorization": `Bearer ${localStorage.getItem("token")}`
        }
    });
    
    // Add a request interceptor
    instance.interceptors.request.use(function (config) {

        // attach X-Request-ID headers from the request body
        // when sending a post request.
        if(config.method.toUpperCase() == "POST") {
            config.headers["X-Request-ID"] = config.data.idempotentKey
        }
        
        return config;
    }, function (error) {
        // Do something with request error
        return Promise.reject(error);
    });
    
    // Add a response interceptor
    instance.interceptors.response.use(function (response) {
        // Any status code that lie within the range of 2xx cause this function to trigger
        // Do something with response data]
        return response;
    }, function (error) {
        // Any status codes that falls outside the range of 2xx cause this function to trigger
        // Do something with response error

        if(error.response) {
            const STATUS_NOT_FOUND = 404;
            const color = error.response.status == STATUS_NOT_FOUND ? "warning" : "error";
            store.dispatch("ui/snackbar/show", { color, text: error.response.data.message })
        } else {
            store.dispatch("ui/snackbar/show", { color: "error", text: error })
        }

        return Promise.reject(error);
    });

    return instance;
}

export default createInstance;